import { observer } from 'mobx-react-lite'
import MindsetsStore, { MindsetsStoreProvider } from './MindsetsStore'
import useStore from 'reusable/mobx-store-utils'
import useInitialMount from 'reusable/hooks/useInitialMount'
import Skeleton from '@mui/material/Skeleton'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import MindsetCategoryIcon from './MindsetCategoryIcon'
import FlexAlignRight from 'reusable/mui/utilities/FlexAlignRight'
import Button from '@mui/material/Button'
import Add from '@mui/icons-material/Add'
import MindsetsDialog from './MindsetsDialog'
import { namingConfig, namingConfigLowerCase } from '@gap/utils/config/naming-config'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import Box from '@mui/material/Box'
import PhotoOutlined from '@mui/icons-material/PhotoOutlined'
import { themeConfig }from '@gap/shared/theme'
import Typography from '@mui/material/Typography'

export default observer(function Mindsets() {
   const orgGuardStore = useOrgGuardStore()
   const mindsetsStore = useStore(sp => new MindsetsStore(sp), { orgGuardStore })

   useInitialMount(() => {
      mindsetsStore.fetch()
   })

   if (mindsetsStore.loader.isLoading) {
      return (
         <>
            <FlexAlignRight>
               <Button variant="contained" startIcon={<Add />} disabled>Create {namingConfigLowerCase.mindset.singular}</Button>
            </FlexAlignRight>
            <Grid container spacing={2} sx={{ mt: 2 }}>
               {Array(9).fill('').map((_n, i) => <Grid key={i} size={4}>
                  <Skeleton sx={{ height: '315px', display: "block", borderRadius: '16px' }} variant="rectangular" animation="wave" />
               </Grid>)}
            </Grid>
         </>
      );
   }

   return (
      <MindsetsStoreProvider store={mindsetsStore}>
         <MindsetsDialog />

         <FlexAlignRight>
            <Button variant="contained" startIcon={<Add />} onClick={mindsetsStore.modifyMindsetModal.open}>Create {namingConfigLowerCase.mindset.singular}</Button>
         </FlexAlignRight>

         <Grid container spacing={3} sx={{ mt: 2 }}>
            {!mindsetsStore.mindsets.length && <Typography variant="body1">No mindsets find. Try adding one</Typography>}

            {mindsetsStore.mindsets.map(mindset => (
               <Grid
                  key={mindset.id}
                  data-id={mindset.id}
                  onClick={mindsetsStore.editMindset}
                  sx={{
                     cursor: 'pointer'
                  }}
                  size={{
                     xs: 12,
                     sm: 12,
                     md: 6,
                     lg: 4,
                     xl: 4
                  }}>
                  <Card sx={{ borderRadius: '16px' }}>
                     <CardContent sx={{ p: 0, "&:last-child": { pb: 1 } }}>
                        <Box sx={{ display: 'flex', height: '225px', justifyContent: 'center', alignItems: 'center', backgroundColor: themeConfig.primary[100] }}>
                           {!mindset.imageFileUrl && <PhotoOutlined sx={{ color: themeConfig.primary[300], fontSize: 64 }} />}
                           {mindset.imageFileUrl && <img
                              src={mindset.imageFileUrl}
                              style={{
                                 maxWidth: '100%',
                                 maxHeight: '100%',
                                 width: 'auto',
                                 height: 'auto'
                              }}
                              alt={`${namingConfig.mindset.singular} image`}
                           />}
                        </Box>
                        <CardHeader
                           title={mindset.name}
                           subheader={mindset.description}
                           avatar={<MindsetCategoryIcon category={mindset.categoryIcon} />}
                        />
                     </CardContent >
                  </Card>
               </Grid>
            ))}
         </Grid>
      </MindsetsStoreProvider>
   );
})
